import { SelectChangeEvent, SelectProps } from '@mui/material'
import React, { FC, useCallback, useContext, useEffect } from 'react'

import useAccessTokenAndShopId from '../../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { RO_CLOSED } from '../../../models/Status'
import { NotificationContext } from '../../../providers'
import {
  useGetUsersWithPermissionQuery,
  useUpdateRepairOrderMutation
} from '../../../redux/api'
import { GetUsersWithPermissionActEnum, RepairOrderEntry } from '../../../sdk'
import { ModifyObjectType } from '../../../utils'
import { AdvisorSelectUI } from './AdvisorSelectUI'

type Props = ModifyObjectType<
  SelectProps,
  {
    repairOrder: RepairOrderEntry
  }
>

export const AdvisorSelect: FC<Props> = ({ repairOrder, ...props }) => {
  const { accessToken, shopId } = useAccessTokenAndShopId()
  const { setNotice } = useContext(NotificationContext)
  const { data: advisors } = useGetUsersWithPermissionQuery({
    authorization: accessToken,
    shop: shopId,
    act: GetUsersWithPermissionActEnum.AssignToRepairOrder
  })

  const [updateRepairOrder, { isSuccess }] = useUpdateRepairOrderMutation()
  const handleAdvisorChange = useCallback(
    async (event: SelectChangeEvent<unknown>) => {
      await updateRepairOrder({
        authorization: accessToken,
        repairOrderEntry: {
          ...repairOrder,
          info: {
            ...repairOrder.info,
            serviceAdvisor:
              typeof event.target.value === 'string'
                ? event.target.value
                : undefined
          }
        }
      })
    },
    [accessToken, repairOrder, updateRepairOrder]
  )
  useEffect(() => {
    if (isSuccess) {
      setNotice('Service advisor has been updated.')
    }
  }, [isSuccess, setNotice])
  return (
    <>
      {advisors && repairOrder && (
        <AdvisorSelectUI
          advisor={repairOrder.info!.serviceAdvisor}
          advisorOptions={advisors}
          handleAdvisorChange={handleAdvisorChange}
          disabled={repairOrder.info?.status === RO_CLOSED}
          {...props}
        />
      )}
    </>
  )
}
